import { AccordionItem, Strong, Stack, Text, List } from 'braid-design-system';
export const Definitions = () => (
  <AccordionItem label="Definitions" id="definitions">
    <List type="number">
      <Stack space="medium">
        <Text>In these Terms:</Text>
        <List type="alpha">
          <Text>
            <Strong>Advertiser</Strong> means a party that has placed (or
            intends to place) an advertisement on our websites and apps.
          </Text>
          <Text>
            <Strong>Candidate</Strong> means an individual using our websites or
            apps for job seeking purposes and/or responding to a job
            advertisement posted on our websites or apps.
          </Text>
          <Text>
            <Strong>Data</Strong> refers to any information sourced or accessed
            by your Recruitment Software via the SEEK API including, without
            limitation, Candidates&apos; job applications, Profiles and Personal
            Information.
          </Text>
          <Text>
            <Strong>Detrimental Change</Strong> has the meaning given in clause
            2b) of these Terms.
          </Text>
          <Text>
            <Strong>Mutual Customers</Strong> means an Advertiser that uses your
            Recruitment Software to assist with their recruitment activities
            through our websites and apps.
          </Text>
          <Text>
            <Strong>Notice Period</Strong> has the meaning given in clause 2b)
            of these Terms.
          </Text>
          <Text>
            <Strong>our websites and apps</Strong> means our SEEK, Jobstreet by
            SEEK (excluding Jobstreet Express) and Jobsdb by SEEK employment
            websites and apps.
          </Text>
          <Text>
            <Strong>Partner Hub</Strong> means talent.seek.com.au/partners.
          </Text>
          <Text>
            <Strong>Personal Information</Strong> is defined as “personal
            information” or “personal data” by applicable Privacy Laws or
            regulations relating to the collection, use or storage of opinion or
            information that identifies or could reasonably identify an
            individual. This includes facts and opinions, whether they are true
            or not.
          </Text>
          <Text>
            <Strong>Privacy Laws</Strong> means the applicable privacy and data
            protection laws as may be in force from time to time which regulate
            the collection, use, disclosure, storage of and granting of access
            rights to Personal Information.
          </Text>
          <Text>
            <Strong>Profile</Strong> means a SEEK Profile, Jobstreet by SEEK
            Profile, or Jobsdb by SEEK Profile (where applicable) page where
            Candidates create personal profiles on our websites and apps by
            inputting their Personal Information.
          </Text>
          <Text>
            <Strong>Recruitment Software</Strong> means a software application
            used and/or developed by you for the purposes of integrating with
            the SEEK API.
          </Text>
          <Text>
            <Strong>SEEK API</Strong> means an Application Programming Interface
            that provides you programmatic access to our websites and apps.
          </Text>
          <Text>
            <Strong>SEEK Group</Strong> means SEEK Limited and its related
            bodies corporate, as defined in the Australian Corporations Act 2001
            (Cth). References to “we” and “us” (and related terms) means the
            SEEK Group unless otherwise stated.
          </Text>
          <Text>
            <Strong>SEEK Group Branding</Strong> means the logos, trade marks,
            business name and domain names owned by a member of the SEEK Group
            that are provided to you.
          </Text>
          <Text>
            <Strong>SEEK Developer Site</Strong> means developer.seek.com and/or
            devportal.seek.com.au, whichever is applicable to you.
          </Text>
          <Text>
            <Strong>Talent Search Connect</Strong> means the Talent Search
            Connect product which we may offer to Advertisers.
          </Text>
          <Text>
            <Strong>Term</Strong> has the meaning given to in in clause 49 of
            these Terms.
          </Text>
        </List>
      </Stack>
    </List>
  </AccordionItem>
);
